<template>
    <button @click.prevent :class="classes">
        <slot></slot>
    </button>
</template>

<script>
    export default {
        props: ['active', 'as'],

        computed: {
            classes() {
                return this.active
                    ? 'inline-flex items-center px-1 pt-1 leading-5 text-blue-600 focus:outline-none transition duration-150 ease-in-out'
                    : 'inline-flex items-center px-1 pt-1 leading-5 text-gray-600 hover:text-blue-600 focus:outline-none focus:text-gray-700 transition duration-150 ease-in-out'
            }
        }
    }
</script>
